import { useIntl } from 'react-intl';
import CreateUserGroup from '../../../../assets/create_user_group.webp';
import { CounterList } from '../CounterList';

export const CreateUserGroupExplained = () => {
    const intl = useIntl();

    const title = intl.formatMessage({ id: 'intl-msg:infoDialog.features.createUserGroup' });

    return (
        <div className={'row'} data-testid={'Create User'}>
            <div className={'col-xs-12'}>
                <h4>{title}</h4>
                <div className={'margin-bottom-25'}>
                    <img src={CreateUserGroup} alt={'tdv'} className={'max-width-75pct'} />
                </div>
                <CounterList chapter={'createUserGroup'} count={3} />
            </div>
        </div>
    );
};
